import React, { useContext, useState } from "react";
import {
  CustomModal,
  PlanCards,
  LoaderWrapper,
} from "../../../../../components";
import { get, isEmpty } from "lodash";
import {
  getAdvancedPathWithParam,
  MANAGE_TRANSFER_ROUTES,
  MANAGE_CENSUS_ROUTES,
} from "../../../../../utils";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../../abstracts";
import ManageDistributionLayout from "../../../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { useHistory } from "react-router-dom";
import InvestmentDetails from "../TransferRequest/InvestmentDetail/InvestmentDetails";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import {
  appLayoutStore,
  globalToastInfo,
  manageDistributionStore,
  saveRebalanceRequest,
  saveTransferRequest,
  setManageDistributionToastInfo,
} from "../../../../../contexts";
import { getRebalanceDetails } from "../../../../../services";

const RebalanceSummaryContainer = (props) => {
  const history = useHistory();
  const { flow, censusId } = useRouterParams();
  const { state, dispatch } = useContext(manageDistributionStore);
  const { dispatch: globalDispatch } = useContext(appLayoutStore);
  const rebalanceDetails = get(state, "api.data.rebalanceDetails", []);
  const currentHolding = get(state, "currentHoldings", []);
  const [employeeImage, setEmployeeImage] = useState("");
  const [sourceData, setSourceData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState({
    header: "",
    content: "",
    btnTextPrimary: "Yes",
    btnTextSecondary: "No",
    icon: "",
    color: "",
    btnColor: "",
  });

  const { response: rebalanceApiData, loading: loading } = useRequest({
    method: getRebalanceDetails,
    payload: censusId,
    defaultResponse: [],
  });

  useDeepEffect(() => {
    setSourceData(
      !isEmpty(rebalanceDetails)
        ? rebalanceDetails.rebalanceSourceDetails.map((item) => {
            return { ...item, show: false };
          })
        : !isEmpty(rebalanceApiData)
        ? rebalanceApiData.rebalanceDetails.map((item) => {
            return { ...item, show: false };
          })
        : []
    );
  }, [rebalanceApiData]);

  const hideCard = (idx) => {
    setSourceData(
      sourceData.map((item, i) => {
        if (i === idx) {
          return { ...item, show: !item.show };
        }
        return item;
      })
    );
  };

  const buttons = [
    {
      label: "Back",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_TRANSFER_ROUTES.REBALANCE_REQUEST,
            pathParam: [flow, censusId],
          })
        ),
    },
    {
      label: "Submit",
      variant: "primary",
      type: "submit",
      onClick: () => onSubmit(),
    },
  ];

  const onCancelClick = () => {
    let data = {
      ...rebalanceDetails,
      rebalanceStatus: 2,
      isFutureContribution: false,
    };
    saveData(data);
  };

  const onSubmitClick = () => {
    let data = {
      ...rebalanceDetails,
      rebalanceStatus: 2,
      isFutureContribution: true,
    };
    saveData(data);
  };

  const saveData = (data) => {
    setIsLoading(true);
    setIsModalOpen(!isModalOpen);
    saveRebalanceRequest(data, false, dispatch)
      .then((res) => {
        setIsLoading(false);
        if (res.isSuccessfull) {
          globalDispatch(
            globalToastInfo({
              showToast: true,
              toastMessage: "Request saved successfully",
            })
          );
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
              pathParam: [flow, censusId],
            })
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        //error
      });
  };

  const onSubmit = () => {
    setModalData({
      header: "Update Contributions",
      content: "Do you want to save this election for future contributions?",
      btnTextPrimary: "Yes",
      btnTextSecondary: "No",
      icon: faInfoCircle,
      color: "#307BF6",
      btnColor: "#307BF6",
    });
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div>
      <LoaderWrapper isLoading={isLoading}>
        <ManageDistributionLayout
          buttons={buttons}
          layoutHeader="Rebalance summary"
          employeeImage={employeeImage}
        >
          <div className="transfer-container">
            <p className="ft-16 fw-500">Plan Details</p>
            <PlanCards
              plans={
                !isEmpty(rebalanceDetails)
                  ? [rebalanceDetails]
                  : [rebalanceApiData.rebalanceDetails]
              }
              isTransfer={true}
              isViewOnly={true}
            />
            <p className="ft-16 fw-500">Sources</p>
            <InvestmentDetails
              data={sourceData}
              currentHolding={currentHolding}
              hideCard={hideCard}
              isRebalanceSummary={true}
              isViewOnly={true}
            />
          </div>
        </ManageDistributionLayout>
        <CustomModal
          color={modalData.color}
          icon={modalData.icon}
          header={modalData.header}
          content={modalData.content}
          isModalOpen={isModalOpen}
          onCancelClick={onCancelClick}
          onSubmitClick={onSubmitClick}
          btnTextPrimary={modalData.btnTextPrimary}
          btnTextSecondary={modalData.btnTextSecondary}
          btnColor={modalData.btnColor}
        />
      </LoaderWrapper>
    </div>
  );
};
export default RebalanceSummaryContainer;
